export default __webpack_public_path__ + "static/media/bg.4c767e7d.svg";